export default class DefaultModel {
  id: string;
  constructor({ id, ...attrs }) {
    this.id = (id || '').toString();
    if (attrs) {
      Object.assign(this, attrs);
    }
  }
}
